module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.data), function(productData, productIndex) {
    return [_vm._l((_vm.config.componentOptions.fields), function(field, fieldIndex) {
      return [_c('div', {
        style: ({
          'display': field.decoratorOptions && field.decoratorOptions.styleHints.includes('show-label') ? 'inline-block' : 'inline'
        })
      }, [(field.decoratorOptions && field.decoratorOptions.styleHints.includes('show-label')) ? _c('span', [_vm._v("\n          " + _vm._s(field.label) + ":\n        ")]) : _vm._e(), _vm._v(" "), _c(("tablefield-" + (field.decorator)), {
        key: (productIndex + "--" + fieldIndex),
        tag: "component",
        style: (field.newline ? '' : 'display: inline'),
        attrs: {
          "config": field,
          "data": _vm.getCellData(field, productData, 0),
          "product": productData
        }
      })], 1), _vm._v(" "), (fieldIndex + 1 < _vm.config.componentOptions.fields.length) ? [_vm._v("\n        " + _vm._s(_vm.config.componentOptions.fieldSeparator) + "\n      ")] : _vm._e()]
    }), _vm._v(" "), (productIndex + 1 < _vm.data.length) ? _c('hr', {
      staticStyle: {
        "margin": "5px 0"
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-653426d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldCombinedMultirow.vue
// module id = 695
// module chunks = 0